import type { UnsellableMovementRow } from './types'

const STORAGE_KEY = 'erp.inventory.unsellableMovement.v1'

function safeParse(json: string | null): UnsellableMovementRow[] {
  if (!json) return []
  try {
    const parsed = JSON.parse(json)
    if (!Array.isArray(parsed)) return []
    return parsed as UnsellableMovementRow[]
  } catch {
    return []
  }
}

export function listUnsellableMovements(): UnsellableMovementRow[] {
  return safeParse(window.localStorage.getItem(STORAGE_KEY))
}

export function getUnsellableMovement(id: string): UnsellableMovementRow | undefined {
  return listUnsellableMovements().find((r) => r.id === id)
}

export function upsertUnsellableMovement(row: UnsellableMovementRow): void {
  const all = listUnsellableMovements()
  const idx = all.findIndex((r) => r.id === row.id)
  const next = idx >= 0 ? all.map((r, i) => (i === idx ? row : r)) : [row, ...all]
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(next))
}
